export default __webpack_public_path__ + "static/media/flag-gibraltar.11583a35.svg";